import React, { FC } from 'react';

import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import ListOption from '~/components/atoms/ListOption';
import { SideBarItemType } from '~/core/sidebar';
import { checkIsRouteMatch } from '~/helpers/routeMatcher';
import { Typographies } from '~/theme/typography';

import styles from './styles.module.scss';

type Props = {
  groups: Pick<
    SideBarItemType,
    'key' | 'path' | 'getTitle' | 'Icon' | 'onClickCb'
  >[][];
};

const InnerNavigation: FC<Props> = ({ groups }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className={styles.nav}>
      {groups.map((items, groupIndex) => (
        <div className={styles.nav__group} key={groupIndex}>
          {items.map(({ Icon, getTitle, onClickCb, path }, idx) => (
            <div className={styles.nav__item} key={idx}>
              <ListOption
                size="small"
                // @ts-ignore
                onClick={(e): void => {
                  if (path && path !== '#') {
                    navigate(path);
                  }

                  if (onClickCb) {
                    onClickCb(e);
                  }
                }}
                isActive={checkIsRouteMatch(path, location.pathname)}
              >
                <div className={styles.nav__item_icon}>
                  <Icon />
                </div>

                <Typography variant={Typographies.TITLE_SMALL} component="p">
                  {getTitle(t)}
                </Typography>
              </ListOption>
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default InnerNavigation;
